import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = ({ classicHeader, darkTheme }) => {
  const experienceDetails = [
    {
      yearRange: "2023 - 2026",
      title: "Managing Consultant",
      place: "amasol",
      desc: "Team-lead, Project Management and Consulting for Observability",
    },
    {
      yearRange: "2013 - 2023",
      title: "Senior Engineer / Consultant",
      place: "Kofax (now Tungsten Automation)",
      desc: "Solution Design and Development for Enterprise Software",
    },
    {
      yearRange: "2009 - 2013",
      title: "Business Development, Security & Risk Management",
      place: "PayLife Bank",
      desc: "Business development of ATM and banking software, Fraud Prevention of Debit-, Credit Cards and ATM systems.",
    },
  ];

  const educationDetails = [
    {
      yearRange: "2009 - 2023",
      title: "Training",
      place: "Various Locations",
      desc: "Dynatrace Professional Certified, Virtualizations, Backup Solutions, Automation",
    },
    {
      yearRange: "2005 - 2009",
      title: "Law Sciences",
      place: "University of Vienna",
      desc: "Anglo-American law, Qualification in latin, Roman law, Law history",
    },
    {
      yearRange: "1997 - 2004",
      title: "Engineer Degree",
      place: "Higher Technical School Donaustadt",
      desc: "Communication Engineering with focus on Information Technology, Electronics and Computer Design",
    },
  ];

  const skills = [
    {
      name: "Databases (MSSQL, DB2, Oracle, MariaDB, MySQL)",
      percent: 90,
    },
    {
      name: "Web Servers (IIS, Nginx, Apache2, Tomcat, WebSphere, NodeJS)",
      percent: 90,
    },
    {
      name: "Windows Client & Server Operating System",
      percent: 99,
    },
    {
      name: "Scripting (PowerShell, Python)",
      percent: 80,
    },
    {
      name: "Programming (C, C++, C#, Java)",
      percent: 60,
    },
    {
      name: "Web Design (HTML/CSS, JavaScript)",
      percent: 75,
    },
    {
      name: "Linux & Solaris Operating System",
      percent: 80,
    },
    {
      name: "Communication & Security Protocols (e.g. SSL/TLS, SMTP, Fax, VoIP)",
      percent: 95,
    },
    {
      name: "Virtualization & Containerization (Kubernetes, VMware, ...)",
      percent: 90,
    },
    {
      name: "Microsoft Office & Exchange",
      percent: 90,
    },
  ];

  return (
    <section
      id="resume"
      className={"section " + (darkTheme ? "bg-dark-1" : "")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-muted opacity-1" : "text-light opacity-4")
            }
          >
            Summary
          </h2>
          <p
            className={
              "text-9 text-dark fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            {" "}
            Resume
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        <div className="row gx-5">
          {/* My Experience */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Experience
            </h2>
            {experienceDetails.length > 0 &&
              experienceDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
          {/* My Education */}
          <div className="col-md-6">
            <h2
              className={
                "text-6 fw-600 mb-4 " + (darkTheme ? "text-white" : "")
              }
            >
              My Education
            </h2>
            {educationDetails.length > 0 &&
              educationDetails.map((value, index) => (
                <div
                  key={index}
                  className={
                    "bg-white  rounded p-4 mb-4 " +
                    (darkTheme ? "bg-dark" : "bg-white border")
                  }
                >
                  <p className="badge bg-primary text-2 fw-400">
                    {value.yearRange}
                  </p>
                  <h3 className={"text-5 " + (darkTheme ? "text-white" : "")}>
                    {value.title}
                  </h3>
                  <p className={darkTheme ? "text-primary" : "text-danger"}>
                    {value.place}
                  </p>
                  <p className={"mb-0 " + (darkTheme ? "text-white-50" : "")}>
                    {value.desc}
                  </p>
                </div>
              ))}
          </div>
        </div>
        {/* My Skills */}
        <h2
          className={
            "text-6 fw-600 mt-4 mb-4 " + (darkTheme ? "text-white" : "")
          }
        >
          My Skills
        </h2>
        <div className="row gx-5">
          {skills.length > 0 &&
            skills.map((skill, index) => (
              <div key={index} className="col-md-6">
                <p
                  className={
                    " fw-500 text-start mb-2 " +
                    (darkTheme ? "text-light" : "text-dark")
                  }
                >
                  {skill.name}{" "}
                  <span className="float-end">{skill.percent}%</span>
                </p>
                <div
                  className={
                    "progress progress-sm mb-4 " + (darkTheme ? "bg-dark" : "")
                  }
                >
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: skill.percent + "%" }}
                    aria-valuenow={skill.percent}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  />
                </div>
              </div>
            ))}
        </div>
        <div className="text-center mt-5">
          <a
            className="btn btn-outline-secondary rounded-pill shadow-none"
            href={resumeFile}
            download
          >
            Download CV
            <span className="ms-1">
              <i className="fas fa-download" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Resume;
